import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const NUMBERS = [
  { label: "+91 96548 52550", wa: "919654852550" },
  { label: "+91 96548 52529", wa: "919654852529" },
];

const WaIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-sticky-chat">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl bg-white border border-slate-200 shadow-[0_20px_50px_-20px_rgba(15,23,42,0.4)] p-4 w-64"
            data-testid="whatsapp-menu"
          >
            <p className="text-xs font-semibold uppercase tracking-wider text-ink-muted mb-3">Chat with the firm</p>
            {NUMBERS.map((n, i) => (
              <a key={n.wa} href={`https://wa.me/${n.wa}?text=Hello%2C%20I%20need%20a%20Chartered%20Accountant%20in%20Ghaziabad.`}
                target="_blank" rel="noopener noreferrer" data-testid={`whatsapp-option-${i + 1}`}
                className="flex items-center gap-3 rounded-xl px-3 py-2.5 hover:bg-brass-light transition-colors duration-200 text-sm font-semibold text-ink">
                <span className="text-[#25D366]"><WaIcon size={20} /></span> {n.label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        onClick={() => setOpen(!open)}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        data-testid="whatsapp-chat-button"
        aria-label="Chat on WhatsApp"
        className="h-16 w-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_16px_40px_-10px_rgba(37,211,102,0.6)]"
      >
        {open ? <X size={26} /> : <WaIcon />}
      </motion.button>
    </div>
  );
};
